/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */

import { useAppStore, useAuthStore } from '@/store';

/**
 * Page-visibility predicate shared by the sidebar, dashboard and any in-page
 * link (e.g. context-menu actions). When an owner closes a page in Settings,
 * every link pointing at it — menu item, dashboard card, context action — must
 * disappear too. Admins always see everything.
 *
 * @param guiKey one of the keys in DEFAULT_GUI_PAGES (e.g. 'bookings', 'tolls').
 */
export function usePageVisibility(): { isPageVisible: (guiKey: string) => boolean } {
  const { isAdmin } = useAuthStore();
  const { guiSettings } = useAppStore();
  const isPageVisible = (guiKey: string): boolean => {
    if (isAdmin) return true;                 // admin sees all pages, no exceptions
    if (!guiSettings?.pages) return true;     // no config = all visible
    return guiSettings.pages[guiKey]?.visible !== false;
  };
  return { isPageVisible };
}
